import script from "./ComHanketiedotVaatimukset.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComHanketiedotVaatimukset.vue?vue&type=script&setup=true&lang=ts"

import "./ComHanketiedotVaatimukset.vue?vue&type=style&index=0&id=1912a147&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1912a147"]])

export default __exports__